import { client } from "@lib/api";
import useSWR from "swr";

type SupportedCryptoCurrency = {
    id: string
    uiDecimals: number
    assetGroup: string
    priceTicker: string
    network_fee: number
    network: string
    iconUrl: string
}

const useSupportedCryptoCurrency = () => {
    const { data, isLoading, error } = useSWR('/wallet/supported-currencies', client.doGet)
    return { 
        data: data as SupportedCryptoCurrency[] | undefined,
        isLoading,
        error
    }
}

export default useSupportedCryptoCurrency
